<template>
  <el-drawer
    :visible="visible"
    size="70%"
    title="Detalles Salto Comprobantes"
    @close="$emit('close', false)"
  >
    <br />
    <el-row>
      <el-col :span="22" :offset="1">
        <GenericChart
          :title="'Saltos comprobantes por dia'"
          :xAxis="daysChart"
          :manualYAxis="true"
          :show="showChart"
          :data="chartData"
        />
      </el-col>
    </el-row>
    <el-row type="flex" justify="end">
      <div style="margin: 0 50px 0 0">
        <el-button type="primary" @click="Btnreinsertar"
          >Reinsertar comprobantes</el-button
        >
      </div>
    </el-row>
    <el-row>
      <el-col :span="22" :offset="1">
        <rabbey-table-3
          :loading="loading"
          :data="tableData"
          :columns="columns"
          :checkBox="true"
          @selection-change="handleSelectionChange"
          :paginateFromApi="true"
          :paginationApi="{
            currentPage: paginaActual,
            pageSize: totalDeRegistrosPorPagina,
            total: registrosTotal
          }"
          @update-page-size="handleSizeChange"
          @update-current-page="handleCurrentChange"
        />
      </el-col>
    </el-row>
    <br />
  </el-drawer>
</template>

<script>
import { detallesSaltoComprobantesColumns } from "./columns/SaltoComprobanteColumns";
import GenericChart from "@/views/Charts/GenericChart.vue";
import { daysChart, daysChartAsObject } from "@/chartUtils.js";

export default {
  components: {
    GenericChart
  },
  props: {
    tarjeta: String,
    cliente: Number,
    proveedor: Number,
    visible: Boolean,
    month: Number,
    year: Number,
    Total: Number
  },

  data() {
    return {
      daysChartAsObject,
      showChart: false,
      daysChart,
      columns: detallesSaltoComprobantesColumns,
      loading: false,
      currentPage2: 1,
      totalDeRegistrosPorPagina: 10,
      paginaActual: 1,
      registrosTotal: 0,
      tableData: [],
      chartData: [],
      Checked: []
    };
  },

  methods: {
    handleSelectionChange(val) {
      if (val.length <= 0) {
        this.Checked = [];
      } else {
        val.forEach((value) => {
          let { ncf, fecha, rnc_empresa } = value;

          this.Checked.push({
            ncf,
            fecha,
            rnc_empresa
          });
        });
      }
    },
    async Btnreinsertar() {
      if (this.Checked.length > 0) {
        const objet = JSON.stringify([...this.Checked]).toString();

        this.loading = true;

        await this.$http
          .post(
            `/api/tennos/InsertSaltosComprobantes?InsertaComprobantes=${objet}`
          )
          .then((resp) => {
            this.loading = false;

            if ((resp.data > 0) & (resp.data != 500)) {
              this.$message({
                type: "success",
                message: "Comprobantes insertados con exito"
              });
            } else {
              this.$message({
                type: "info",
                message: "Error al insertar Comprobantes"
              });
            }
          });
        await this.GetData();
        this.Checked = [];
      }
    },
    handleSizeChange(val) {
      this.totalDeRegistrosPorPagina = val;
      this.GetData();
    },
    handleCurrentChange(val) {
      this.paginaActual = val;

      this.currentPage2 = this.paginaActual;
      this.GetData();
    },
    format(price) {
      return new Intl.NumberFormat("en-US").format(price);
    },
    ChangeDays() {
      this.paginaActual = 1;
      this.currentPage2 = this.paginaActual;
      this.GetData();
    },
    async GetData() {
      this.Checked = [];
      this.loading = true;
      this.showChart = false;
      await this.$http
        .get(`/api/tennos/DetailsComprobanteSaltos`, {
          params: {
            year: this.year,
            month: this.month,
            page: this.paginaActual,
            recordsPerPage: this.totalDeRegistrosPorPagina,
            EmpresaId: this.proveedor
            // getComprobantes: true
          }
        })
        .then((resp) => {
          const { detailes } = resp.data;
          if (detailes) {
            this.tableData = detailes;
          } else {
            this.tableData = resp.data;
          }

          this.registrosTotal = this.Total;
        })
        .finally(() => {
          this.loading = false;
        });
      this.tableData.forEach((x) => {
        this.daysChartAsObject[new Date(x.fecha).getDate()] += 1;
      });
      this.chartData = Object.values(this.daysChartAsObject);
      this.showChart = true;
    }
  },

  watch: {
    visible(val) {
      if (val) {
        this.GetData();
      } else {
        this.tableData = [];
        this.registrosTotal = 0;
      }
    }
  }
};
</script>

<style scoped>
.el-table td {
  width: 10px;
}
.cell {
  width: 1px;
}
.Table {
  margin: 0 auto;
  padding-left: 200px;
}
.Pagination {
  margin: 0 auto;
}
</style>
